<script setup lang="ts">
import { listingPagePath, useListingPreview, type ListingKind } from '@/composables/listing/use-listing-preview'
import { responseListingLocation } from '@/composables/responses/response-navigation'

const props = defineProps<{ kind: ListingKind, id: string, responseId?: string }>()

const { open } = useListingPreview()
const route = useRoute()
const router = useRouter()
const href = computed(() => props.responseId
  ? router.resolve(responseListingLocation(props.kind, props.id, props.responseId, route.fullPath)).href
  : listingPagePath(props.kind, props.id))

// Keeps the canonical page as href (crawlers, new tab, copy link) while a
// plain click opens the preview over the current list.
function onClick(event: MouseEvent) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
  event.preventDefault()
  void open(props.kind, props.id, props.responseId)
}
</script>

<template>
  <a :href="href" @click="onClick"><slot /></a>
</template>
